import config from 'src/config';

const STRIPE_REDIRECT_URI = config.NODE_ENV === 'production' ? 'https://app.nightpro.co/oauthcallback/stripe' : 'https://app-dev.nightpro.co/oauthcallback/stripe';
const STRIPE_CONNECT_URL = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${config.STRIPE_CLIENT_ID}&scope=read_write&redirect_uri=${STRIPE_REDIRECT_URI}`;

class SettingsVenueBillingCtrl {
  constructor($scope, $q, sdkVenueService, $stateParams, alertService, userPreferencesService, modalService) {
    this.venuePromise = sdkVenueService.readById($stateParams.venueId);

    this.stripeUserId = $stateParams.stripeUserId;

    this.connectStripe = function($event) {
      $event.preventDefault();

      window.location.href = STRIPE_CONNECT_URL;
    };

    this.disconnectStripe = function($event) {
      $event.preventDefault();

      let modalInstance;

      modalService.confirmation({
          modalHeader: 'Disconnect Stripe',
          modalMessage: 'Are you sure you want to disconnect your Stripe account?',
          confirmBtnTxt: 'Disconnect',
          confirmingBtnTxt: 'Disconnecting...',
          size: 'sm'
        })
        .then(result => {
          modalInstance = result.modalInstance;

          if (result && result.confirm) {
            return sdkVenueService.updateById(this.venue.id, {
                paymentProviderAccountId: null
              })
              .then(venue => {
                this.venue = venue;

                alertService.success('Stripe account disconnected');
              });
          }

          return null;
        })
        .finally(() => modalInstance.close());
    };

    this.loading = true;

    this.venuePromise
      .then(venue => {
        this.venue = venue;

        userPreferencesService.setStripeVenue(this.venue.id);

        if (this.stripeUserId) {
          return sdkVenueService.updateById(this.venue.id, {
              paymentProviderAccountId: this.stripeUserId
            })
            .then(updatedVenue => {
              this.venue = updatedVenue;

              this.loading = false;

              alertService.success('Stripe account connected');
            });
        }

        this.loading = false;

        return venue;
      });
  }
}

SettingsVenueBillingCtrl.$inject = [
  '$scope',
  '$q',
  'jsSdk.venue',
  '$stateParams',
  'alertService',
  'userPreferencesService',
  'modalService'
];

export default SettingsVenueBillingCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsVenueBilling/settingsVenueBillingCtrl.js